export type NewsListItemDto = {
  id: string;
  type: string;
  publishedAt: string;
  viewsUniqueCount: number;
};

export type NewsListResponse = {
  items: NewsListItemDto[];
};

async function readErrorMessage(response: Response, fallback: string): Promise<string> {
  try {
    const data = (await response.json()) as { message?: string };
    if (data?.message) return data.message;
  } catch {
    // ignore non-JSON errors
  }
  return fallback;
}

export const newsApi = {
  list: async (): Promise<NewsListResponse> => {
    const response = await fetch("/api/news");
    if (!response.ok) {
      throw new Error(await readErrorMessage(response, "Failed to load news"));
    }
    return response.json() as Promise<NewsListResponse>;
  },

  markSeen: async (accessToken: string): Promise<{ lastSeenNewsAt: string }> => {
    const response = await fetch("/api/news/seen", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    if (!response.ok) {
      throw new Error(await readErrorMessage(response, "Failed to mark news as seen"));
    }
    return response.json() as Promise<{ lastSeenNewsAt: string }>;
  },

  recordView: async (accessToken: string, newsId: string): Promise<void> => {
    const response = await fetch(`/api/news/${encodeURIComponent(newsId)}/view`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    if (!response.ok) {
      throw new Error(await readErrorMessage(response, "Failed to record news view"));
    }
  },
};
